module.exports = __webpack_public_path__ + "static/media/tobiiShirt.cfc4c439.jpg";